export const timeline = {
  today: 'Today',
  yesterday: 'Yesterday',
  emptyTitle: 'No activity yet',
  emptySub: 'Events for this workflow will appear here as they happen.',
  filters: {
    contact: "Contact",
    all: 'All',
    asset: 'Asset',
    inspection: 'Inspection',
    job: 'Job',
    request: 'Request',
    report: 'Report',
  },
  summary: {
    label: 'AI summary',
    sinceToggle: 'Since I last viewed',
    btnSummarise: 'Summarise',
    btnRegenerate: 'Regenerate',
    btnLoading: 'Summarising…',
    loading: 'Reading the timeline…',
    emptyHint: 'Tap Summarise to get a 2-4 sentence overview of this asset.',
    emptyHintSite: 'Tap Summarise to get a 2-4 sentence overview of this site.',
    emptyHintContact: 'Tap Summarise to get a 2-4 sentence overview of this contact.',
    errorFallback: 'Could not load summary. Please try again.',
  },
  events: {
    assetCreated: 'Asset created',
    inspectionStarted: 'Inspection started',
    inspectionCompleted: 'Inspection completed',
    issueRaised: 'Issue raised',
    requestRaised: 'Request raised',
    approvalReceived: 'Approval received',
    quoteReceived: 'Quote received',
    jobCreated: 'Job created',
    jobAssigned: 'Job assigned',
    workCompleted: 'Work completed',
    evidenceAdded: 'Evidence added',
    reportGenerated: 'Report generated',
  },
} as const;
